module.exports = __webpack_public_path__ + "img/logo-min.4268f925.png";